<template>
    <div class="headerBox">
        <div class="log" v-longpress="checkUser"><img  src="/images/logo.png" /></div>
        <div class="name">
            {{userInfo?.Department_Name}}
            <div class="date">营业日期:{{userInfo?.Rpt_Date}}</div>
        </div>
        <div class="mq-state-box">
            <div class="mq-state">
                <template v-if="mqState==1">
                    <span class="icon-box"><i class="dian"></i><i class="dian"></i><i class="dian"></i></span>
                    <div>重连中</div>
                </template>
                <template v-else-if="mqState==2">
                    <span class="icon-box"><i class="iconfont icon-a-zaixian-xian3x"></i></span>
                    <div>在线中</div>
                </template>
                <template v-else>
                    <span class="icon-box"><i class="iconfont icon-a-lixian-xian3x"></i></span>
                    <div>离线中</div>
                </template>
            </div>
        </div>
        <div class="news">
            <div @click="isShowNew=true" >
                <i class="iconfont icon-xinxiaoxishezhi"></i><b class="news-number" v-if="newList?.length>0">{{newList.length}}</b>
                <i class="iconfont icon-a-desk-message" v-if="newList?.length>0"></i>
                <div>消息</div>
            </div>
            <div class="news-tip-box" v-show="isShowNew">
                <div class="tip-title">
                    <div class="nav-bnt selected">数据同步消息</div>
                    <!-- <div class="nav-bnt">通知消息</div> -->
                </div>
                <div class="tip-content">
                    <el-empty description="" v-if="!newList || newList.length==0"></el-empty>
                    <div class="li" v-for="(item,index) in newList" :key="item" v-else>
                        <img class="icon" src="/images/news1.png"/>
                        <div class="text nowrap2">{{index+1}}.{{item.text}}</div>
                    </div>
                    <!-- <div class="li">
                        <img class="icon" src="/images/news1.png"/>促销方案数据修改，请操作【数据同步】
                        <div class="text nowrap2">2.菜单信息修改，请操作【数据同步】</div>
                    </div> -->
                </div>
                <div class="tip-bots">
                    <div class="bnt" @click="isShowNew=false">返回</div>
                    <div class="bnt bnt-confirm" @click="$global.clickSync()">数据同步</div>
                </div>
            </div>
        </div>
        <div class="li-bnt"><i class="iconfont icon-yonghu1"></i><div>{{userInfo?.Login_Name}}</div></div>
        <div class="li-bnt"><i class="iconfont icon-shijian"></i><div>{{timeTxt}}</div></div>
        <!-- <div class="li-bnt" @click="backHome()"><i class="iconfont icon-chexiao"></i><div>返回主界面</div></div> -->
    </div>
</template>

<script>
export default {
    name:"headerBox",
    emits:['checkUser'],
    computed:{
        //消息数据
        newList(){
            return this.$global.newList;
        },
        //mq在线状态
		mqState(){
			return this.$global.mqState;
		},
        userInfo(){
            return this.$parent.userInfo;
        },
        timeTxt(){
            return this.$parent.timeTxt;
        }
    },
    data(){
        return {
            isShowNew:false,
            navMenu:{
				'Order':{key:'Order',name:'点单',icon:'icon-yudiancan',tabIndex:0,url:'diningTable'},
				'Bill':{key:'Bill',name:'账单',icon:'icon-zhangdan',tabIndex:1,url:'bill'},
				'Member':{key:'Member',name:'会员',icon:'icon-huiyuan',tabIndex:2,url:'member'},
				'Report':{key:'Report',name:'报表',icon:'icon-baobiao',tabIndex:3,url:'report'},
				'Config':{key:'Config',name:'设置',icon:'icon-shezhi',tabIndex:4,url:'setup'},
				CloudPosPre:{key:'CloudPosPre',name:'预订',icon:'icon-yuding',tabIndex:5,url:'cloudPosPre'},
			},
            userNavMenu:[],
        }
    },
    mounted(){
        let SysProjects=this.$cacheData.SysProjects.get();
		if(SysProjects && SysProjects.length>0){
			SysProjects.forEach(element=> {
				if(element.Visible){
					let menu=this.navMenu[element.Project_Key];
					if(menu){
						menu.name=element.Project_Name;
						menu.index=element.Project_Index;

						if(element.Project_Key=="CloudPosPre"){
							console.log(element)
							if(element.SysProjectGroups?.length>0){
								this.userNavMenu.push(menu);
							}
						}else{
							this.userNavMenu.push(menu);
						}	
					}
				}
			});
		}
    },
    methods:{
        //用户验证
        checkUser(){
            this.$emit("checkUser");
        },
        //返回主界面
        backHome(){
            if(this.userNavMenu?.length>0){
                let pathname=""
                let fastFood=this.userInfo.Business_Types.find(it=>it.value!='4');
                if(fastFood){
                    if(fastFood.value=='1'){
                        pathname="fastFoodDetail";
                        
                    }else{
                        pathname="diningTable";
                    }
                }
                if(!pathname && this.userNavMenu.length>1){
                    pathname=this.userNavMenu[1].url;
                }
                if(pathname){
                    this.$router.push('/home/'+pathname);
                    return;
                }
               
            }else{//退出登陆

            }
        },
    }

}
</script>

<style lang="scss" >
@import './headerBox.scss';
</style>